import './DynamicProfile.scss';
import { Extent, Map, MapView, SpatialReference } from 'cd-eft/utils/esriTypes';
import React, { useEffect, useRef, useState } from 'react';
import { DynamicProfileStoreBase } from 'cd-eft/models/Stores/DynamicProfile/DynamicProfileStoreBase';
import stores from 'cd-eft/models/Stores';
import { Loader } from '../LoadingSpinner/LoadingSpinner';

const libraryStore = stores.AppStore.projectsLibraryStore;

interface IDynamicAlignmentProfileProps {
  profileStore: DynamicProfileStoreBase | undefined;
  editable: boolean;
}

const DynamicAlignmentProfile = (props: IDynamicAlignmentProfileProps) => {
  const [waitingInit, setWaitingInit] = useState(true)
  const profileMapViewRef = useRef<MapView>();
  if (!profileMapViewRef.current) {
    const spatialReference = new SpatialReference({ wkid: 102965 });
    const extent = new Extent({ xmin: 0, ymin: 0, xmax: 100, ymax: 110, spatialReference });

    profileMapViewRef.current = new MapView({ map: new Map({ layers: [] }), extent, spatialReference });
  }

  useEffect(() => {
    if (profileMapViewRef.current) {

      const sr: SpatialReference = libraryStore.projectSpatialReference!;
      props.profileStore?.initialize(profileMapViewRef.current, sr, props.editable, 'alignment');
      setWaitingInit(false);

      profileMapViewRef.current.container = document.getElementById('alignment-Profile') as HTMLDivElement;
      if (props.profileStore) props.profileStore.startLengthyProcess = (state: boolean) => setWaitingInit(state)
    }
  }, [props.editable, props.profileStore]);

  return (
    <div id={'profile-and-peripherals-container'}>
      <div id={'alignment-Profile'} style={{ position: "relative" }}>
        <div className="mt-5" hidden={!waitingInit}>
          <Loader message={'Loading profiles ...'} />
        </div>
      </div>
      <div title='Zoom to Extent' className='esri-icon-applications esri-widget--button esri-widget esri-interactive home profile-btn' onClick={() => { if (profileMapViewRef.current && props.profileStore?.maxExtent) profileMapViewRef.current.extent = props.profileStore?.maxExtent }}></div>
    </div>
  );
};

export { DynamicAlignmentProfile };
